import React, { useState } from 'react';
import InputQuestion from './InputQuestion';
import YesNoQuestion from './YesNoQuestion';
import SelectQuestion from './SelectQuestion';
import Info from './Info';
import styles from './Question.module.css';


// Helper function to check if the question should be displayed
const shouldDisplayQuestion = (data, answers, questionMap) => {
  if (!data.pid) {
    return true;
  }

  const parentQuestion = questionMap[data.pid];
  const parentAnswer = answers[data.pid];

  if (parentQuestion.type === "yesno") {
    return parentAnswer === true;
  }

  if (parentQuestion.type === "group") {
    return true;
  }

  if (parentQuestion.type === "select") {
    return false;
  }

  return false;
};

// Question component to handle different question types
function Question({ data, handleAnswerChange, answers, questionMap, isMarked }) {
  const { type } = data;
  const answer = answers[data.id];
  const [showInfo, setShowInfo] = useState(false); // define state for info visibility

  const displayQuestion = shouldDisplayQuestion(data, answers, questionMap);

  if (!displayQuestion) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.questionRow}>
        <div className={styles.questionContainer}>
          {
            type === 'input' ? <InputQuestion {...{ data, answer, handleAnswerChange, isMarked }} /> :
              type === 'yesno' ? <YesNoQuestion {...{ data, answer, handleAnswerChange, isMarked }} /> :
                type === 'select' ? <SelectQuestion {...{ data, answer, handleAnswerChange, questionMap, answers, isMarked }} /> :
                  type === 'group' ? <GroupQuestion {...{ data, handleAnswerChange, answers, questionMap, isMarked }} /> :
                    <p>Unexpected question type: {type}</p>
          }
        </div>
        {data.details &&
          <button className={styles.infoButton} title="Details anzeigen" onClick={() => setShowInfo(!showInfo)}>info</button>
        }

      </div>
      {data.details && showInfo && <Info info={data.details} />} {/* render Info component conditionally */}
    </div>
  );
}

// GroupQuestion component for 'group' type question
function GroupQuestion({ data, isMarked }) {
  return (
    <div className={isMarked ? styles.marked : ''}>
      <label className={styles.label}>{data.question}</label>
    </div>
  );
}

export default Question;